<template>
  <div class="pe-2" style=" overflow-y:auto;overflow-x: hidden;height: calc(100vh - 172px)">
    <el-dialog width="60vw" top="5vh" title="Chi tiết công việc" v-if="isShowTodoDetail" :close-on-click-modal="false"
               :visible.sync="isShowTodoDetail" :destroy-on-close="true">
      <TodoDetail :selected-account="selectedAccount" :todo-item="todoItem" @closeDialog="isShowTodoDetail = false" />
    </el-dialog>
    <div v-for="(item,index) in data_list" :key="index">
      <div class="d-flex mb-2 pointer" style="">
        <div @click="selectItem(item)" class="w-100 card-order p-3 todo-hover">
          <div class="flex-1 ">
            <div class="d-flex justify-content-between align-items-center">
              <div v-if="item.statusTodo === 1"
                   class="d-flex justify-content-between align-items-center  fw-bolder text-1-line text-break font-size-16 pe-2 me-2"
                   style="border-right: 1px solid #e0e4e8 ">
                <el-avatar :src="getCreator(item).avatar" :size="24" class="me-2" />
                <span>{{ getCreator(item).displayName }}</span>
              </div>
              <div class="fw-bolder text-1-line text-break font-size-16 "
                   v-html="$options.filters.highlight(item.description.trim(), app.highlightTask)"
                   v-bind:style="item.description.trim().length > 0?  'color: #1769D7':'color:#7589a3'">
                {{ item.description.trim().length > 0 ? item.description : "(Không có tiêu đề)" }}
              </div>
              <div style="margin-left: auto" class="d-flex justify-content-center align-items-center">
                <span class="me-2">{{ formatDistanceTime(item.updateTime) }}</span>
                <!--                <img v-if="item.statusTodo !== 1" class="me-2 zavatar" :src="getAvatar(item)" />-->
                <div class="d-flex align-self-end me-1" v-if="item.statusTodo !== 1" >
                  <div v-for="(itemA,indexA) in item.assignees.slice(0,4)" :key="indexA">
                    <div v-bind:style="indexA===0?'margin-left:0':'margin-left:-5px'">
                      <el-avatar :src="getAvatar(itemA)" :size="20" />
                    </div>
                  </div>
                  <div v-if="item.assignees.length>4"
                       style="margin-left:-5px;width: 20px;height: 20px;background-color: #B1B5B9;border-radius: 999px;border: 1px solid whitesmoke"
                       class="d-flex justify-content-center align-items-center">
                    <div class="font-size-12 text-white">+</div>
                  </div>
                </div>


                <img v-if="item.statusTodo === 0" @click.stop.prevent="ding(item,selectedAccount.accountId)"
                     class="p-1 icon-todo " src="/assets/icon/Alert-Notify.svg" />
                <img @click.stop.prevent="selectItem(item)" class="p-1 icon-todo " src="/assets/icon/message.svg" />

                <el-dropdown placement="bottom-start" trigger="hover" cđõlass="h-100">
                  <div class="d-flex h-100 el-dropdown-link align-items-center justify-content-center">
                    <img @click.stop.prevent="" class="p-1 icon-todo" src="/assets/icon/more.svg" />
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <!--                    <el-dropdown-item>-->
                    <!--                      <div class="d-flex"><img class="me-3" src="/assets/icon/direct-right.svg" />-->
                    <!--                        <div>Bình luận</div>-->
                    <!--                      </div>-->
                    <!--                    </el-dropdown-item>-->
                    <el-dropdown-item>
                      <div class="d-flex" v-if="isShowItemDoneTodo(item)"
                           @click="finishTask(item,selectedAccount.accountId)"><img class="me-3"
                                                                                    src="/assets/icon/ic_done.svg" />
                        <div>Hoàn thành công việc</div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="false">
                      <div class="d-flex"><img class="me-3" src="/assets/icon/ic_origin.svg" />
                        <div>Xem tin nhắn gốc</div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="divider-custom-zalo"></div>
                      <div @click="removeTask(item)" v-if="isCreator(item)" class="d-flex">
                        <img style="margin-left: 3px" class="me-3" src="/assets/icon/ic_remove.svg" />
                        <div style="color: #7A7F83">Xoá công việc</div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>


              </div>
            </div>
            <span style="white-space: pre-line" class="text-break text-2-line-new zfont font-size-14 mb-2"
                  v-html="$options.filters.highlight(item.content, app.highlightTask)">
              {{ item.content }}
            </span>
            <div class="zfont font-size-14 ">
              <el-button @click.stop.prevent="acceptTask(item,selectedAccount.accountId)"
                         v-if="isShowButtonAcceptTodo(item)" size="mini"
                         type="primary">Nhận việc
              </el-button>
              <el-button @click.stop.prevent="finishTask(item,selectedAccount.accountId)"
                         v-if="isShowButtonDoneTodo(item)" size="mini"
                         style="background: #218656;color: white">Hoàn thành
              </el-button>
              <el-button @click.stop.prevent="rejectTask(item,selectedAccount.accountId)"
                         v-if="isShowButtonRejectTodo(item,selectedAccount.accountId)" size="mini"
                         style="background: white;color: #B5393B;">Từ chối
              </el-button>
              <span v-else id="regexText" v-html="getStatus(item,selectedAccount.accountId)" />
              <div v-if="isOutDate(item)" style="float: right;"
                   class="zalo-text-danger me-3">Quá hạn
              </div>
              <!--              <div v-if="isOutDate(item)" style="float: right;"-->
              <!--                   class="zalo-text-danger me-3">Thời hạn: {{ getDueDate(item) }} - Quá {{ getDaysOutDate(item) }}-->
              <!--              </div>-->
              <!--              <div v-else-if="isShowDate(item)" class="me-3" style="float: right">-->
              <!--                Thời hạn: {{ getDetailDueDate(item) }}-->
              <!--              </div>-->
            </div>

          </div>
        </div>
      </div>
    </div>
    <!--    <scroll-loader :loader-method="loadMore"
                       :loader-disable="isDisable">
          <div style="margin-right: 16px" v-loading="true"></div>
        </scroll-loader>-->

  </div>
</template>

<script>
import TodoDetail from "./TodoDetail";
import moment from "moment/moment";

export default {
  name: "ZaloTodoList",
  components: { TodoDetail },
  props: {
    data_list: {
      type: Array
    },
    selectedAccount: {
      type: Object
    }
  },
  data() {
    return {
      todoItem: {},
      isShowTodoDetail: false
    };
  },
  computed: {

    /*    isDisable() {
          if (this.data_list.find(s => s.statusTodo === 0)) {
            return this.hasLoadMore.creator !== true;
          } else if (this.data_list.find(s => s.statusTodo === 1)) {
            return this.hasLoadMore.assignees !== true;
          } else if (this.data_list.find(s => s.statusTodo === 2)) {
            return this.hasLoadMore.watchers !== true;
          }
          return true;
        }*/
  },
  methods: {
    getCreator(item) {
      if (item.creator === this.selectedAccount.accountId) {
        return this.selectedAccount;
      }
      let data = this.app.listContactsAccount.find(s => s.uid === item.creator);
      if (data) {
        return data;
      } else {
        return {};
      }
    },
    // refundTask(){
    //
    // },

    // ding(item) {
    //   let req = {
    //     accountId: this.selectedAccount.accountId,
    //     params: JSON.stringify({ id: item.id })
    //   };
    //
    //     this.$http.post("/api/todo/ding", req).then(s => {
    //       if (JSON.parse(JSON.stringify(s.data)).error_code === 0) {
    //         this.$bus.$emit("updateTask", item);
    //       }
    //     });
    //
    // },
    removeTask(item) {
      let req = {
        accountId: this.selectedAccount.accountId,
        params: item.id
      };
      this.$confirm("Công việc này sẽ không còn hiển thị trên danh sách của bạn. Bạn có chắc rằng bạn muốn xoá công việc này không?", "Cảnh báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(async () => {
        this.$http.post("/api/todo/removeTask", req).then(s => {
          if (s.data.error_code === 0) {
            this.app.isShowTodoDetail = false;
            this.alert("success", "Thao tác thành công");
            item.action = "delete";
            this.$bus.$emit("updateTask", item);
          } else {
            return this.alertError(s.data.error_message);
          }
        });
      });
    },
    // finishTask(item) {
    //   let req = {
    //     accountId: this.selectedAccount.accountId,
    //     params: JSON.stringify({ id: item.id, status: 1 })
    //   };
    //   this.$confirm("Thông báo hoàn thành công việc sẽ được gửi tới " + item.creator.dpn + ".", "Warning", {
    //     confirmButtonText: "Xác nhận",
    //     cancelButtonText: "Hủy",
    //     type: "warning"
    //   }).then(async () => {
    //     this.$http.post("/api/todo/status", req).then(s => {
    //       if (JSON.parse(JSON.stringify(s.data)).error_code === 0) {
    //         this.$bus.$emit("updateTask", item);
    //       }
    //     });
    //   });
    // },
    confirmTask(item) {
      let req = {
        accountId: this.selectedAccount.accountId,
        params: JSON.stringify({ id: item.id, status: -1 })
      };
      this.$http.post("/api/todo/status", req).then(s => {
        if (JSON.parse(JSON.stringify(s.data)).error_code === 0) {
          this.$bus.$emit("updateTask", item);
        }
      });
    },
    /*
        loadMore() {
          if (this.data_list.find(s => s.statusTodo === 0)) {
            this.$bus.$emit("loadMoreTodo", { role: "creator", scrollId: this.hasLoadMore.scrollIdCreator });
          }
          if (this.data_list.find(s => s.statusTodo === 1)) {
            this.$bus.$emit("loadMoreTodo", { role: "assignees", scrollId: this.hasLoadMore.scrollIdAssignees });
          }
          if (this.data_list.find(s => s.statusTodo === 2)) {
            this.$bus.$emit("loadMoreTodo", { role: "watchers", scrollId: this.hasLoadMore.scrollIdWatchers });
          }
        },
    */
    stopPropagation(e) {
      e.stopImmediatePropagation();
    },
    // isShowItemRemove(item) {
    //
    //   if (item.assignees.find(s => s.userId === this.selectedAccount.accountId) && item.assignees.find(s => s.userId === this.selectedAccount.accountId).userId == item.creator && item.statusTodo === 0) {
    //     return true;
    //   }
    //   return false;
    // },
    isShowButtonRemove(item) {
      return this.isShowButtonAcceptTodo(item) && this.isShowItemRemove(item);
    },
    isShowButtonDoneTodo(item) {
      return this.isShowButtonAcceptTodo(item) && this.isShowItemDoneTodo(item);
      // let item1 = item.assignees.find(s => s.userId === this.selectedAccount.accountId && s.status === 1);
      // return !item1 && item.status !== 1;
    },
    isShowButtonAcceptTodo(item) {
      return item.statusTodo === 1 && item.status === -1 && item.assignees.find(s => s.status === -1 && s.userId === this.selectedAccount.accountId);
    },


    isShowItemDoneTodo(item) {
      if ([-1, 0].includes(item.status) && item.statusTodo === 0) {
        return true;
      }
      // if (item.statusTodo === 1 && [-1, 0].includes(item.status) && item.assignees.find(s => s.userId === this.selectedAccount.accountId) && item.assignees.find(s => s.userId === this.selectedAccount.accountId).userId == item.creator) {
      if (item.statusTodo === 1 && [-1, 0].includes(item.status) && item.assignees.find(t => t.userId === this.selectedAccount.accountId && t.status !== 1)) {
        return true;
      }
      return false;
    },
    selectItem(item) {
      this.todoItem = item;
      this.isShowTodoDetail = true;
    },
    formatDistanceTime(time) {
      let date = new Date(Number(time));
      let now = new Date();
      if (now.getDate() === date.getDate() && now.getMonth() === date.getMonth() && now.getFullYear() === date.getFullYear())
        return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
      return this.formatDateTimeShort(Number(time));
    },
    formatDateTimeShort(time) {
      var date = new Date(time);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      return hours + ":" + minutes + " " + day + "/" + month + "/" + date.getFullYear();
    },
    getDaysOutDate(item) {
      let nowTime = new Date().getTime();
      let diff = Math.floor((nowTime - item.dueDate) / 86400000);
      if (diff === 0) {
        return "hạn";
      } else {
        return diff + " ngày";
      }
    },

    isOutDate(item) {
      return item.status !== 1 && item.dueDate !== -1 && item.dueDate < new Date().getTime();
    },
    isShowDate(item) {
      return item.status !== 1 && item.dueDate !== -1 && item.dueDate > new Date().getTime();
    },
    getAvatar(item) {
      if (item.userId === this.selectedAccount.accountId) {
        return this.app.accounts.find(s => s.accountId === this.selectedAccount.accountId).avatar;
      }
      let data = this.app.listContactsAccount.find(s => s.uid === item.userId);
      if (data) {
        return data.avatar;
      } else {
        return "";
      }
    },

    getDueDate(item) {
      let date = item.dueDate;
      if (item.dueDate === -1) {
        return "Không thời hạn";
      }
      return moment(date).format("DD/MM");
    }
  },
  created() {

  },
  mounted() {
    this.$bus.$on("updateTask", () => this.isShowTodoDetail = false);
  },
  beforeDestroy() {
    this.$bus.$off("updateTask");
  }
};
</script>

<style scoped>
.todo-hover:hover {
  background-color: #eff2f7;
}

.zavatar {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  margin-right: 0;
}

.zfont {
  color: #7589a3;
  font-weight: 450;
}

.icon-todo:hover {
  cursor: pointer;
  background-color: #bac4d1;
  border-radius: 999px;
}

.card-order {
  padding: 5px;
  transition: 0.3s;
  border: 1px solid #e0e4e8;
  border-radius: 0.5rem
}
</style>
